import { createRoot } from 'react-dom/client';
import { StaticRouter } from 'react-router-dom';
import loadable from '@loadable/component';

import apolloWrapper from '@hoc/apolloWrapper';
import { getClientLocale } from '@utils/i18n';

const SeoHubTagBlock = loadable(
  async () => {
    const module = await import('@containers/SeoHubTag');
    return module.SeoHubTagContainer;
  },
);

// const
const seoHubBlock = document
  .querySelector('#js-seo-hub-tag');

const SeoHubWithApollo = apolloWrapper(SeoHubTagBlock);

if (seoHubBlock) {
  const root = createRoot(seoHubBlock);
  const { routerBasename } = getClientLocale();

  root.render(
    <StaticRouter
      location={window.location}
      basename={routerBasename}
    >
      <SeoHubWithApollo />
    </StaticRouter>,
  );
}
